import { useMemo } from 'react';
import { useGrades } from '../../Common/hooks/useGrades';
import { useDomains } from '../../Common/hooks/useDomains';
import { useAssignmentSkills } from '../../Common/hooks/useAssignmentSkills';
var useDictionaries = function () {
    var _a = useGrades(), grades = _a.response, isGradesLoading = _a.isLoading;
    var _b = useDomains(), domains = _b.response, isDomainsLoading = _b.isLoading;
    var _c = useAssignmentSkills(), skills = _c.response, isSkillsLoading = _c.isLoading;
    var data = useMemo(function () {
        if (!grades || !domains || !skills)
            return null;
        return {
            grades: grades,
            domains: domains,
            skills: skills,
        };
    }, [domains, grades, skills]);
    return {
        response: data,
        isLoading: isGradesLoading || isDomainsLoading || isSkillsLoading,
    };
};
export { useDictionaries };
